import React from "react";
import {
  FundraiserForAccount,
  LoggedInAccount,
} from "../../../Interfaces/AccountUsers";
import "./MobileView.css";
import GeneralDashboardTableView from "../../../components/RefactoredDashboard/GeneralDashboard/DesktopTableView";
import {
  useNavigateToJoinFundraiser,
  calculateActiveFundraisers,
  FilterFundraisersByEndDate,
} from "../../../components/RefactoredDashboard/DashboardCommonFunctions";
import FundraisersAwaitingCoordinator from "../../../components/Dashboard/FundraisersAwaitingCoordinator";

interface GeneralDashboardSeparateMobileViewProps {
  loggedInAccount: LoggedInAccount; // Replace 'any' with the actual type of user account
  fundraisers: FundraiserForAccount[];
  filterView: string | undefined;
  setFilterView: (option: string | undefined) => void;
}

const GeneralDashboardSeparateMobileView: React.FC<
  GeneralDashboardSeparateMobileViewProps
> = ({ loggedInAccount, fundraisers, filterView, setFilterView }) => {
  const navigateToJoinFundraiser = useNavigateToJoinFundraiser();

  return (
    <div>
      <div className="general-dashboard-mobile-header">
        <h3>Hey {loggedInAccount.first_name}</h3>
        <p>Your fundraisers, sorted by end date.</p>
      </div>
      <div className="general-dashboard-mobile-join-fundraiser">
        <div className="general-dashabord-mobile-join-fundraiser-left-side">
          <p>GOT AN INVITE?</p>
          <p>Join a Fundraiser</p>
        </div>
        <div className="general-dashboard-mobile-join-fundraiser-right-side">
          <button onClick={navigateToJoinFundraiser}>Enter Code →</button>
        </div>
      </div>
      <div className="general-dashboard-mobile-fundraisers-section">
        <div className="general-dashboard-mobile-fundraisers-header">
          <div>
            <h4>My Fundraisers</h4>
            <span className="general-dashboard-mobile-fundraisers-count">
              {calculateActiveFundraisers(fundraisers)} active
            </span>
          </div>
          <FilterFundraisersByEndDate
            filterView={filterView}
            setFilterView={setFilterView}
          />
        </div>
        <FundraisersAwaitingCoordinator user_id={loggedInAccount.id} />
        <GeneralDashboardTableView fundraiser={fundraisers} isMobile={true} />
      </div>
    </div>
  );
};

export default GeneralDashboardSeparateMobileView;
